"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _marketing = require("@/api/marketing");
var _product = require("@/api/product");
var _timeOptions = _interopRequireDefault(require("@/libs/timeOptions"));
var _vuex = require("vuex");
var _activity = _interopRequireDefault(require("./activity.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'creatSeckill',
  components: {
    activity: _activity.default
  },
  directives: {
    // 计算是否滚动到最下面
    selectLoadMore: {
      bind: function bind(el, binding) {
        // 获取element-ui定义好的scroll盒子
        var SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
        SELECTWRAP_DOM.addEventListener('scroll', function () {
          if (this.scrollHeight - this.scrollTop < this.clientHeight + 1) {
            binding.value();
          }
        });
      }
    }
  },
  data: function data() {
    return {
      activeName: '',
      search: {
        limit: this.$constants.page.limit[0],
        page: 1,
        name: ''
      },
      form: {
        id: '',
        productList: []
      },
      rules: {
        name: [{
          required: true,
          message: '请输入活动名称',
          trigger: 'blur'
        }],
        share: [{
          required: true,
          message: '请选择优惠比例',
          trigger: 'change'
        }],
        timeVal: [{
          required: true,
          message: '请选择活动日期'
        }],
        discount: [{
          required: true,
          message: '请选择优惠方式'
        }],
        timeVal2: [{
          type: 'array',
          required: true,
          message: '请输入选择秒杀场次',
          trigger: 'change'
        }],
        id: [{
          required: true,
          message: '请选择秒杀活动',
          trigger: 'change'
        }]
      },
      timeVal2: [],
      pickerOptions: _timeOptions.default,
      spikeTimeList: [],
      multipleSelection: [],
      activityType: null,
      proData: [],
      listLoading: false,
      checkAll: false,
      isIndeterminate: true,
      activityList: [],
      loading: false,
      keyNum: 0,
      isShowCheck: false,
      attrValue: [],
      //普通商品sku数组
      auditStatus: 0,
      //审核状态
      productId: 0 //普通商品id
    };
  },
  mounted: function mounted() {
    this.$store.dispatch('product/getAdminProductClassify');
    if (this.$route.params.activityId) {
      this.form.id = this.$route.params.activityId;
      this.activeName = 'second';
    } else {
      if (!this.isCopy) {
        this.getActivityList();
      } else {
        this.getInfo();
      }
      this.activeName = 'first';
    }
    this.isCkecked();
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['merPlatProductClassify'])), {}, {
    //判断是否有活动id
    isEdit: function isEdit() {
      return this.$route.params.activityId ? true : false;
    },
    //判断添加商品是否可编辑
    isCopy: function isCopy() {
      if (this.$route.params.activityId && localStorage.getItem('seckillData')) return true;
      if (this.$route.params.activityId && !localStorage.getItem('seckillData')) return false;
      if (!this.$route.params.activityId && localStorage.getItem('seckillData')) return true;
    }
  }),
  methods: {
    // 下拉加载更多
    selectLoadMore: function selectLoadMore() {
      this.search.page = this.search.page + 1;
      if (this.search.page > this.totalPage) return;
      this.getActivityList(); // 请求接口
    },
    // 远程搜索
    remoteMethod: function remoteMethod(query) {
      var _this2 = this;
      this.loading = true;
      this.search.name = query;
      this.search.page = 1;
      this.activityList = [];
      setTimeout(function () {
        _this2.loading = false;
        _this2.getActivityList(); // 请求接口
      }, 200);
    },
    // 活动列表
    getActivityList: function getActivityList() {
      var _this3 = this;
      (0, _marketing.seckillActivityListApi)(this.search).then(function (res) {
        _this3.totalPage = res.totalPage;
        _this3.total = res.total;
        _this3.activityList = _this3.activityList.concat(res.list);
      });
    },
    // 判断选中没有
    isCkecked: function isCkecked() {
      var checked = this.proData.filter(function (item) {
        return item.checked;
      });
      if (checked.length) {
        this.isShowCheck = false;
      } else {
        this.isShowCheck = true;
      }
    },
    //全选
    handleCheckAllChange: function handleCheckAllChange(val) {
      var _this4 = this;
      this.isIndeterminate = !this.isIndeterminate;
      this.proData.forEach(function (item) {
        _this4.$set(item, 'checked', val);
      });
      this.isCkecked();
    },
    //单选
    handleCheckOneChange: function handleCheckOneChange(val, row) {
      var totalCount = this.proData.length;
      var someStatusCount = 0;
      this.$set(row, 'checked', val);
      this.proData.forEach(function (item) {
        if (item.checked === val) {
          someStatusCount++;
        }
      });
      this.checkAll = totalCount === someStatusCount ? val : !val;
      this.isIndeterminate = someStatusCount > 0 && someStatusCount < totalCount;
      this.isCkecked();
    },
    //详情
    getInfo: function getInfo() {
      var _this5 = this;
      this.listLoading = true;
      var info = JSON.parse(localStorage.getItem('seckillData'));
      this.auditStatus = info.auditStatus;
      this.productId = info.productId;
      this.form.productList = info;
      this.form.id = info.activityId;
      this.listLoading = false;
      if (info.auditStatus === 3) {
        //调取商品详情接口 获取商品规格id。因为重新提交 相当于添加商品，取普通商品规格id
        (0, _product.productMarketingListApi)({
          productId: info.productId,
          activityId: info.activityId,
          marketingType: 2
        }).then(/*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(res) {
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  if (res) {
                    _this5.attrValue = res.list[0].attrValue || [];
                    _this5.getAttrValue(res.list);
                  }
                case 1:
                  return _context.a(2);
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      } else {
        this.getAttrValue([info]);
      }
    },
    back: function back() {
      if (this.isEdit) {
        this.$router.push({
          path: "/marketing/seckill/seckillActivity"
        });
      } else {
        this.$router.push({
          path: "/marketing/seckill/list"
        });
      }
    },
    //行删除
    handleDelete: function handleDelete(index, row) {
      var _this6 = this;
      this.$modalSure('删除该秒杀商品吗？').then(function () {
        var i = _this6.proData.findIndex(function (item) {
          return item == row;
        });
        _this6.proData.splice(i, 1);
      });
    },
    setActivity: function setActivity(data, type) {
      var _this7 = this;
      if (type == 1) {
        if (data.type == 0) {
          this.proData.forEach(function (item) {
            item.children.forEach(function (item1) {
              if (item.checked) {
                _this7.$set(item1, 'activityPrice', data.price);
              }
            });
          });
        } else {
          this.proData.forEach(function (item) {
            item.children.forEach(function (item1) {
              if (item.checked) {
                _this7.$set(item1, 'activityPrice', item1.price * data.discount / 100);
              }
            });
          });
        }
      } else if (type == 2) {
        this.proData.forEach(function (item) {
          item.children.forEach(function (item1) {
            if (item.checked) {
              _this7.$set(item1, 'quota', data.activity_stock);
            }
          });
        });
      }
    },
    //添加商品
    addGoods: function addGoods() {
      if (!this.form.id) return this.$message.warning('请先选择秒杀活动');
      var _this = this;
      this.$modalActivityProduct(function (row) {
        _this.listLoading = false;
        _this.getAttrValue(row);
      }, 'many', _this.proData, Number(_this.form.id), 1);
    },
    // 选中商品
    getAttrValue: function getAttrValue(row) {
      var _this = this;
      row.map(function (item) {
        _this.$set(item, 'children', item.attrValue);
        _this.$set(item, 'sort', 0);
        _this.$set(item, 'checked', true);
        item.children.map(function (i) {
          _this.$set(i, 'name', i.sku);
          _this.$set(i, 'merName', item.merName);
          _this.$set(i, 'categoryName', item.categoryName);
          _this.$set(i, 'quota', i.quota ? i.quota : 0);
          _this.$set(i, 'quotaShow', i.quotaShow ? i.quotaShow : 0);
          // _this.$set(i, 'activityPrice', 0.01);
          _this.$set(i, 'activityPrice', 0.01);
          _this.$set(i, 'price', i.price);
        });
      });
      _this.proData = row;
      _this.isCkecked();
    },
    batchDel: function batchDel() {
      var _this8 = this;
      this.$modalSure("\u6279\u91CF\u5220\u9664\u5546\u54C1\u5417\uFF1F").then(function () {
        _this8.proData = _this8.proData.filter(function (item) {
          return !item.checked;
        });
      });
    },
    //设置活动价
    setPrice: function setPrice(type) {
      this.keyNum = Math.random();
      this.$refs.activityModal.type = type;
      this.$refs.activityModal.showStatus = true;
    },
    // 具体日期
    onchangeTime: function onchangeTime(e) {
      this.form.timeVal = e;
      this.form.startDate = e ? e[0] : '';
      this.form.endDate = e ? e[1] : '';
    },
    // 提交
    submitForm: function submitForm(formName) {
      var _this9 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          var total = 0;
          var price = 0;
          _this9.proData.map(function (item) {
            item.children.map(function (i) {
              total += i.quota;
              price += i.activityPrice;
            });
          });
          if (!total && total !== 0) return _this9.$message.warning('商品限量不能为空');
          if (!price) return _this9.$message.warning('商品秒杀价格不能为空');
          if (total < _this9.proData.length) return _this9.$message.warning('商品限量总和不能小于0');
          var list = _this9.proData;
          //this.auditStatus === 3 获取商品规格id。因为重新提交 相当于添加商品，取普通商品规格id
          if (_this9.auditStatus === 3) {
            _this9.form.productList = list.map(function (item) {
              return {
                id: _this9.productId,
                sort: 0,
                attrValue: item.attrValue.map(function (item1, idx) {
                  return {
                    activityPrice: item1.activityPrice,
                    attrValueId: _this9.attrValue[idx].id,
                    quota: item1.quota
                  };
                })
              };
            });
          } else {
            _this9.form.productList = list.map(function (item) {
              return {
                id: item.id,
                sort: 0,
                attrValue: item.attrValue.map(function (item1) {
                  return {
                    activityPrice: item1.activityPrice,
                    attrValueId: item1.id,
                    quota: item1.quota
                  };
                })
              };
            });
          }
          // this.form.id = this.$route.params.activityId ? this.$route.params.activityId : this.form.id;
          (0, _marketing.seckillProAddApi)(_this9.form).then(function (res) {
            _this9.$message.success('添加成功');
            if (_this9.$route.params.activityId) {
              _this9.$router.push({
                path: "/marketing/seckill/seckillActivity"
              });
            } else {
              _this9.$router.push({
                path: "/marketing/seckill/list"
              });
            }
          }).catch(function (res) {});
        } else {
          return false;
        }
      });
    }
  }
};